var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"itemNotice-li"},[_c('router-link',{staticClass:"itemNotice-a",attrs:{"to":'/paperArticle/'+_vm.articleId+'/'+_vm.tabName}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"itemNotice-span"},[_vm._v(_vm._s(_vm.create_time))]),_vm._v(" "),_c('hr')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5a83064","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/itemPaper.vue
// module id = null
// module chunks = 